import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';

export interface BackButtonProps {
  url: string;
  label: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ url, label }) => {
  return (
    <Link
      href={url}
      className="flex gap-snug-xl items-center label-md label-neutral-moderate pb-snug-xl no-underline"
    >
      <ArkIcon iconName="chevron-left" size="1rem" />
      {label}
    </Link>
  );
};
